module["exports"] = [
  "se",
  "nu",
  "info",
  "com",
  "org"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sv/internet/domain_suffix.js
// module id = 1249
// module chunks = 0